import { render, staticRenderFns } from "./DrawerMenu.vue?vue&type=template&id=2931c9f8&scoped=true&lang=pug&"
import script from "./DrawerMenu.vue?vue&type=script&lang=js&"
export * from "./DrawerMenu.vue?vue&type=script&lang=js&"
import style0 from "./DrawerMenu.vue?vue&type=style&index=0&id=2931c9f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2931c9f8",
  null
  
)

export default component.exports